import React, { useEffect, useState } from "react";
import "./Quick_quiz_stepform.css";
import { useDispatch, useSelector } from "react-redux";
import Step_one from "./step-one/Step_one";
import QuizEngine from "./engine/QuizEngine";
import ContactLensRouter from "./engine/ContactLensRouter";
import { spectacleFramesFlow } from "./flows/spectacleFramesFlow";
import { sunglassesFlow } from "./flows/sunglassesFlow";
import { spectacleLensFlow } from "./flows/spectacleLensFlow";
import { contactLensFlow } from "./flows/contactLensFlow";
import {
  getAllCategories, getAllGender, getAllMaterial,
  getAllFrameType, getAllColor, getAllShape,
} from "../../features/master/masterSlice";

const CATEGORY_FLOWS = {
  5: { flow: spectacleFramesFlow, kind: "engine" },
  2: { flow: sunglassesFlow, kind: "engine" },
  1: { flow: spectacleLensFlow, kind: "engine" },
  3: { flow: contactLensFlow, kind: "contactLens" },
};

const Quick_quiz_stepform = ({ filters, onFilterChange, handleFilterReset }) => {
  const [category, setCategory] = useState(null);
  const dispatch = useDispatch();

  const allCategories = useSelector((state) => state.master.categories);
  const allGender = useSelector((state) => state.master.all_gender);
  const allMaterial = useSelector((state) => state.master.all_material);
  const allFrameType = useSelector((state) => state.master.all_frame_type);
  const allColor = useSelector((state) => state.master.all_color);
  const allShape = useSelector((state) => state.master.all_shape);

  useEffect(() => {
    dispatch(getAllCategories());
    dispatch(getAllGender());
    dispatch(getAllFrameType());
    dispatch(getAllShape());
  }, [dispatch]);

  useEffect(() => {
    if (category?.id) {
      dispatch(getAllMaterial({ category_id: category.id }));
      dispatch(getAllColor({ category_id: category.id }));
    }
  }, [dispatch, category]);

 useEffect(() => {
  handleFilterReset();
}, []);

  if (!category) {
    return (
      <section className="QuizStepMain">
        <div className="userForm">
          <div className="step-Form-Container">
            <div className="container-fluid">
              <Step_one
                allCategories={allCategories}
                onFilterChange={onFilterChange}
                onSelectCategory={setCategory}
              />
            </div>
          </div>
        </div>
      </section>
    );
  }

  const entry = CATEGORY_FLOWS[category.id];
  if (!entry) return null;

  return (
    <section className="QuizStepMain">
      <div className="userForm">
        <div className="step-Form-Container">
          <div className="container-fluid">
            {entry.kind === "contactLens" ? (
              <ContactLensRouter
                flow={entry.flow}
                categoryId={category.id}
                onFilterChange={onFilterChange}
                prevToCategoryPicker={() => setCategory(null)}
              />
            ) : (
              <QuizEngine
                flow={entry.flow}
                categoryId={category.id}
                onFilterChange={onFilterChange}
                masterData={{
                  all_gender: allGender,
                  all_material: allMaterial,
                  all_frame_type: allFrameType,
                  all_color: allColor,
                  all_shape: allShape,
                }}
                prevToCategoryPicker={() => setCategory(null)}
              />
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Quick_quiz_stepform;